import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.send_report_error."

export function SendReportErrorToast(props: Props) {
  const {
    id,
    code = null,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1016: // too many reports requested
          return polyglot.t(`${polyglotPrefix}max_reports_requested_body`)
        case 1017: // not enough data
          return polyglot.t(`${polyglotPrefix}not_enough_data_body`)
        default:
          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
